var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExhibitionModuleWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon beurs white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-beurs-white",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "baseline-explore-24px-copy",
    transform: "translate(9.000000, 9.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5,14.6888441 C15.4956317,14.6888441 14.6888441,15.4956317 14.6888441,16.5 C14.6888441,17.5043683 15.4956317,18.3111559 16.5,18.3111559 C17.5043683,18.3111559 18.3111559,17.5043683 18.3111559,16.5 C18.3111559,15.4956317 17.5043683,14.6888441 16.5,14.6888441 Z M16.5,0.0349462366 C7.41129032,0.0349462366 0.0349462366,7.41129032 0.0349462366,16.5 C0.0349462366,25.5887097 7.41129032,32.9650538 16.5,32.9650538 C25.5887097,32.9650538 32.9650538,25.5887097 32.9650538,16.5 C32.9650538,7.41129032 25.5887097,0.0349462366 16.5,0.0349462366 Z M20.1058468,20.1058468 L6.62096774,26.3790323 L12.8941532,12.8941532 L26.3790323,6.62096774 L20.1058468,20.1058468 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExhibitionModuleWhite);
export default __webpack_public_path__ + "static/media/exhibition-module-white.e3fdf091a78327b1db756f8706a14594.svg";
export { ForwardRef as ReactComponent };